<template>
  <router-link
    :to="handleRouterTo()" >
    单双大小历史
  </router-link>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    handleRouterTo () {
      return {
        name: 'LotteryChartDetail',
        query: {
          id: this.id,
          chart: 'dslsHistory'
        }
      }
    }
  }
}
</script>
